<template>
  <div class="cms-custom-header">
    <div class="cms-csh-info" :style="infoStyle">
      <div class="cms-csh-back" @click="goBack">
        <svg
          style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
          t="1750410975494" viewBox="0 0 1024 1024" version="1.1"
          xmlns="http://www.w3.org/2000/svg" p-id="4730"
        >
          <path d="M768 149.942857L691.2 73.142857 256 512l435.2 438.857143 76.8-76.8-358.4-362.057143z" p-id="4731"></path>
        </svg>
      </div>
      <span class="cms-csh-title">{{ customHeaderSetting.title }}</span>

      <div
        class="cms-csh-more"
        @click="moreClick"
        v-if="customHeaderSetting.rightBtnText"
      >
        <svg
          style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
          t="1750954929628" viewBox="0 0 1024 1024"
          version="1.1" xmlns="http://www.w3.org/2000/svg"
          p-id="6852" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">
          <path d="M828.2 131.4H702c-12.1-39.1-48.6-67.5-91.7-67.5H415.7c-43.1 0-79.6 28.4-91.7 67.5H196c-37.6 0-68 30.4-68 68v690.9c0 37.6 30.4 68 68 68h632.1c37.6 0 68-30.4 68-68V199.4c0.1-37.5-30.4-68-67.9-68zM513 724.3c0 17.6-14.3 31.9-31.9 31.9h-159c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9h159c17.6 0 31.9 14.3 31.9 31.9z m224.4-177.9c0 17.6-14.3 31.9-31.9 31.9h-385c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9h385.1c17.6 0 31.8 14.3 31.8 31.9z m0-177.9c0 17.6-14.3 31.9-31.9 31.9h-385c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9h385.1c17.6 0 31.8 14.3 31.8 31.9z" p-id="6853"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: '#333',
      bgColor: '#fff',
      a: 1
    }
  },
  computed: {
    isCustomHeader() {
      return this.$root.isCustomHeader
    },
    customHeaderSetting() {
      return this.$root.customHeaderSetting
    },
    infoStyle() {
      return `color:${this.color};background-color:${this.bgColor};`
    }
  },
  mounted() {
    if (this.$root.customHeaderSetting.theme == 'gradient') {
      this.a = 0
      this.color = `#fff`
      this.bgColor = `rgba(255, 255, 255, ${this.a})`
      const scroller = document.querySelector('.scroll-touch')
      if (scroller) {
        scroller.addEventListener('scroll', this.scroll.bind(this))
        this.$once('hook:beforeDestroy', () => {
          scroller.removeEventListener('scroll', this.scroll)
        })
      }
    }
    if (window.WOWNOW) {
      // 隐藏头部
      window.WOWNOW.setNavigationBarStyle({ style: 2 })
      // 页面将要离开
      window.addEventListener('pagehide', function (e) {
        console.log('pagehide')
        // 显示头部
        window.WOWNOW.setNavigationBarStyle({ style: 0 })
      })
      // 用户通过浏览器后退返回到当前页面
      window.addEventListener('pageshow', function (e) {
        console.log('pageshow', e)
        if (e.persisted) {
          // 隐藏头部
          window.WOWNOW.setNavigationBarStyle({ style: 2 })
        }
      })
    }
  },
  methods: {
    goBack() {
      if (this.$root.customHeaderSetting.leftBtnClick) {
        this.$root.customHeaderSetting.leftBtnClick()
      } else {
        if (this.$root.isWownowApp) {
          if (window.history.length == 1) return window.WOWNOW.closeWindow()
          if (window.history.length <= 2 && document.referrer === '') return window.WOWNOW.closeWindow()
        }
        window.history.back()
      }
    },
    moreClick() {
      if (this.$root.customHeaderSetting.rightBtnClick) {
        this.$root.customHeaderSetting.rightBtnClick()
      }
    },
    scroll(e) {
      const scrollTop = e.target.scrollTop
      if (scrollTop > 100) {
        this.a = 1
      } else {
        this.a = scrollTop / 100
      }
      const c = 255 - (255 - 51) * this.a
      this.color = `rgb(${c}, ${c}, ${c})`
      this.bgColor = `rgba(255, 255, 255, ${this.a})`
    }
  }
}
</script>

<style lang="stylus" scoped>
.cms-custom-header{
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 44px;
  background-color: transparent;
  .cms-csh-info{
    position: relative;
    width: 100%;
    height: 44px;
  }
  .cms-csh-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: currentColor;
  }

  .cms-csh-back{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding-left: 10px;
    width: 100px;
    height: 44px;
    font-size: 18px;
    text-align: center;
    color: currentColor;
  }

  .cms-csh-more{
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    height: 44px;
    font-size: 20px;
    font-weight: 400;
    color: currentColor;
    text-align: center;
  }
}
</style>
